import { filterServicesForVehicle } from './filterServicesForVehicle';

/**
 * Tipo y servicio de mantenimiento por defecto al agendar.
 */
export function isMaintenanceServiceType(serviceTypeOrId, serviceTypes = []) {
  const type =
    serviceTypeOrId && typeof serviceTypeOrId === 'object'
      ? serviceTypeOrId
      : serviceTypes.find(
          (t) => Number(t.id) === Number(serviceTypeOrId),
        );
  return String(type?.name || '')
    .toLowerCase()
    .includes('mantenimiento');
}

export function isUrgentServiceType(serviceTypeOrId, serviceTypes = []) {
  const type =
    serviceTypeOrId && typeof serviceTypeOrId === 'object'
      ? serviceTypeOrId
      : serviceTypes.find(
          (t) => Number(t.id) === Number(serviceTypeOrId),
        );
  return String(type?.name || '')
    .toLowerCase()
    .includes('urgente');
}

export function findMaintenanceServiceType(serviceTypes = []) {
  return (
    serviceTypes.find((t) => isMaintenanceServiceType(t)) || serviceTypes[0]
  );
}

export function findDefaultMaintenanceService(
  services = [],
  serviceTypes = [],
  vehicle = null,
) {
  const maintenanceType = findMaintenanceServiceType(serviceTypes);
  const typeId = maintenanceType?.id;

  const forVehicle = vehicle
    ? filterServicesForVehicle(services, vehicle)
    : services;

  const ofType = typeId
    ? forVehicle.filter((s) => Number(s.serviceTypeId) === Number(typeId))
    : forVehicle;

  const list = ofType.length ? ofType : forVehicle;

  const byName = list.find((s) =>
    String(s.name || '')
      .toLowerCase()
      .includes('mantenimiento'),
  );
  if (byName) return { service: byName, serviceTypeId: typeId || byName.serviceTypeId };

  const first = list[0];
  if (first) return { service: first, serviceTypeId: typeId || first.serviceTypeId };

  return { service: null, serviceTypeId: typeId || null };
}

export function formatDateInput(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function addDaysToDateInput(dateStr, days) {
  const base = dateStr ? new Date(`${dateStr}T12:00:00`) : new Date();
  base.setDate(base.getDate() + days);
  return formatDateInput(base);
}

/** Próximo día hábil (salta sábado y domingo). Por defecto desde mañana. */
export function getNextBusinessDate(fromDate = new Date(), minDaysAhead = 1) {
  const date = new Date(fromDate);
  date.setHours(12, 0, 0, 0);
  date.setDate(date.getDate() + minDaysAhead);
  while (date.getDay() === 0 || date.getDay() === 6) {
    date.setDate(date.getDate() + 1);
  }
  return date;
}

export function getNextBusinessDateInput(
  dateStr = null,
  minDaysAhead = 1,
) {
  const base = dateStr ? new Date(`${dateStr}T12:00:00`) : new Date();
  return formatDateInput(getNextBusinessDate(base, minDaysAhead));
}
